export default {
    // title 
    titleMarketUpdates: '시장 업데이트',
    titleTrendingCompanies: '트렌딩 기업',
    titleInvite: "초대 및 보상 받기",
    titleOnboarding: "온보딩 키트",


    exportingLeadsToACSV: "CSV로 리드 내보내기에는 {count} 크레딧이 사용됩니다.|CSV로 리드 내보내기에는 {count} 크레딧이 사용됩니다.",
    

    // trending companies

    // invite
    forReferrals: "추천인:",
    inviteBtn: '초대',
    copyLink: '링크 복사',
    shareYourReferralLink: '추천 링크를 공유하거나 이메일을 입력하여 다른 사람을 초대하세요. 그들이 가입하면 보상을 받을 수 있습니다!',
    forTeamInvites: "팀 초대 (크레딧을 얻기 위해):",
    assignTeamInvites: "팀 초대 할당",
    lookingToGrowYourTeam: "팀을 성장시키고 싶으세요? 초대를 할당하고 다른 사람이 가입할 때마다 크레딧을 얻으세요!",
    addMultipleAddresses: "쉼표로 여러 주소 추가",
    greatProgress: "훌륭한 진행입니다! 계속 초대하여 전체 {count} 크레딧을 잠금 해제하세요.",
    startInviting: '초대를 시작하고 최대 {count} 크레딧을 얻으세요!',
    allSet: "모두 완료되었습니다! {count} 크레딧을 얻으셨습니다. 초대해주셔서 감사합니다!",


    // custom insight
    addYourOwnCustomInsights: "나만의 맞춤형 인사이트 추가",
    companyKeyMilestones: "회사의 주요 이정표",
    listMajorCompetitors: "동종 업계의 주요 경쟁사 목록",
    analyzeMarketPresence: "회사의 시장 존재 분석",
    poweredByAi: "AI 기반",

    // onboarding kit
    grantedUponCompletion: '완료 시 {count} 지급',
    granted_complete: '{count} 크레딧 보너스가 지급되었습니다!',


    // ai
    meetRonnaAi: "RonnaAi를 만나보세요 - 당신의 스마트 비즈니스 어시스턴트",
    askAnything: "무엇이든 물어보세요...",
    askQuestionsExploreStrategies: '질문을 하고, 전략을 탐색하고, 맞춤형 즉각적인 인사이트를 얻으세요.',
    limitedView: "제한된 보기",
    viewFullCompanyDetails: "전체 회사 세부 정보 보기",
    recentThreads: "최근 스레드",
    recentlyViewed: "최근에 본 항목",
    companyAndWebsite: "회사 / 웹사이트",
    noResultsAskAi: "결과가 없나요? RonnaAI에 관련 정보를 문의하세요",
    allSearchResultsFor: "{count}에 대한 모든 검색 결과",
    searchForAnything: "무엇이든 검색",
    pressEnter: "ENTER 누르기",
    askRonnaAI: "RonnaAI에게 질문:",
    clickToChatWithRonnaAI: "클릭하여 RonnaAI와 채팅하고 더 많은 세부 정보 얻기",
    useRonnaAIToExploreBusinessDirectories: "RonnaAI를 사용하여 비즈니스 디렉토리, 인사이트 등을 즉시 탐색하세요.",
    ronnaAI: 'RonnaAI',
    findSearchHistory: "검색 기록 찾기",
    Today: '오늘',
    "7 Days": "7일",
    '30 Days': "더 보기",
    deleteRecord: "기록 삭제",
    newChat: "새 채팅",
    aiTabAnswer: "답변",
    aiTabCompanies: "회사",
    aiTabSources: "출처",
    processingYourRequest: "요청 처리 중...",
    thinkingDeeply: "깊이 생각 중",
    generatingAPlan: "계획 생성 중",
    noHistoryYet: "아직 기록이 없습니다",

    // advertisement
    targetLocation: "타겟 위치",
    open_ad: "광고 열기",
    ad_type_label: {
      text: "텍스트 소재",
      image: "이미지 소재",
      video: "동영상 소재",
      carousel: "캐러셀 소재",
      other: "소재",
    },
    est_impressions: "예상 노출수",
    ads: "광고",

    // expansion signals (Phase 1)
    expansion: {
        companyFacts: {
          duplicateProfileNotice: "중복된 프로필입니다.",
          viewCurrentProfile: "현재 프로필 보기",
          duplicateProfileTip: "이 프로필은 중복입니다. 현재 프로필을 여세요",
        },
        jobsInsights: {
            heading: "채용 현황",
            windowReadout: "최근 {n}일",
            windowHint: "이 기간에 채용 중인 공고를 집계",
            kpiOpen: "채용 공고",
            kpiPosted: "게시된 공고",
            openSub: "전체 공개 {n}건",
            kpiPace: "채용 속도",
            kpiTopFunction: "주요 직무",
            kpiMarkets: "채용 지역",
            newSub: "신규 {n}건",
            trendVsPrior: "이전 대비",
            marketShare: "{pct}% {place}",
            nRoles: "{n}개 직무",
            momentumLabel: "채용 모멘텀",
            velAccel: "가속 중",
            velSlow: "둔화 중",
            velSteady: "안정적",
            mover: "{flag} {place} — 지난 한 달 {n}건",
            moverSenior: "{flag} {place} — 지난 한 달 {n}건, 주로 {tier}",
            moverNew: "· 신규 시장",
            exploreLabel: "탐색",
            exploreHint: "막대를 탭하면 직무·지역·직급의 연관을 볼 수 있어요",
            showingOf: "{total}개 중 {n}개",
            clearAll: "지우기",
            listFilteredBy: "필터:",
            notClassified: "{n}개 미분류",
            openListTitle: "게시된 공고",
            openListNote: "게시 · {window}",
            leadTopFunction: "{label} 최다 — {count}개",
            leadTopLocation: "{pct}%가 {place}",
            tier_executive: "임원",
            tier_director: "디렉터",
            tier_manager: "매니저",
            tier_senior: "시니어",
            tier_junior: "주니어",
            byFunction: "직무별",
            byLocation: "지역별",
            bySeniority: "직급별",
            thisCompany: "이 회사",
            narrFast: "{company}이(가) 빠르게 확장 중 — 최근 {days}일간 {n}개 공고를 게시, 이전 대비 {pct}% 증가.",
            narrUp: "{company}이(가) 적극적으로 채용 중 — 최근 {days}일간 신규 {n}개 공고, 이전 대비 {pct}% 증가.",
            narrSteady: "{company}의 채용은 안정적 — 최근 {days}일간 {n}개 공고, 이전 기간과 비슷.",
            narrDown: "{company}의 채용이 둔화 — 최근 {days}일간 {n}개 공고, 이전 대비 {pct}% 감소.",
            narrQuiet: "{company}에는 {open}개 채용 공고가 있으나 최근 신규 게시는 적습니다.",
            narrMix: "{fn} 중심이며 {loc}에 집중.",
            narrMixSenior: "{fn} 중심이며 {loc}에 집중. 이 중 {pct}%가 리더십 직무.",
            loadError: "채용 인사이트를 불러오지 못했습니다",
            retry: "다시 시도",
            none: "—",
        },
        adsInsights: {
            eyebrow: "광고 활동",
            openListTitle: "진행 중인 광고",
            lead: "{markets}개 시장에서 진행 중인 캠페인 {n}개",
            kpiActive: "진행 중 광고",
            kpiMarkets: "타겟 시장",
            kpiTopChannel: "주요 채널",
            kpiTopFormat: "주요 형식",
            leadReach: "최대 {reach} 도달",
            kpiMomentum: "모멘텀",
            windowSub: "최근 {n}일",
            trendVsPrior: "이전 대비",
            sparkLabel: "광고 시작",
            moreInsights: "인사이트 더보기",
            lessInsights: "인사이트 숨기기",
            byReach: "도달 규모별 (노출)",
            reach_lt_1k: "1K 미만",
            reach_1k_10k: "1K–10K",
            reach_10k_50k: "10K–50K",
            reach_50k_100k: "50K–100K",
            reach_100k_500k: "100K–500K",
            reach_500k_1m: "500K–1M",
            reach_1m_plus: "100만+",
            reachPeak: "최대 {peak}",
            byMarket: "타겟 시장별",
            byChannel: "채널별",
            byFormat: "형식별",
            byPlacement: "게재 위치별",
            exploreLabel: "탐색",
            exploreHint: "막대를 탭하면 도달·시장·채널의 관계가 보입니다",
            exploringOf: "최근 {total}개 중 {n}개 탐색 중",
            showingOf: "광고 {total}개 중 {n}개",
            clearAll: "지우기",
            leadTopMarket: "{pct}%가 {place} 타겟",
            leadTopChannel: "{pct}%가 {channel} 경유",
            noImpression: "이 광고에는 노출 데이터가 없습니다",
            noImpressionN: "{n}개는 노출 데이터 없음",
            noMarket: "타겟 시장 데이터 없음",
            noMarketN: "{n}개는 타겟 시장 없음",
            marketLed: "주로 {place}",
            creatives: "최근 광고 소재",
            nCampaigns: "광고 {n}개",
            loadError: "광고 인사이트를 불러오지 못했습니다",
            retry: "다시 시도",
            none: "—",
        },
        newsInsights: {
            eyebrow: "미디어 보도",
            lead: "지난 {days}일간 언급 {n}건",
            kpiMentions: "언급 수",
            kpiMomentum: "모멘텀",
            kpiPositive: "확장 신호",
            kpiRisk: "리스크 신호",
            kpiTopics: "주제",
            kpiSources: "출처",
            ledBy: "{x} 중심",
            windowSub: "최근 {n}일",
            trendVsPrior: "이전 대비",
            sparkLabel: "보도량",
            fundingLatest: "최근 라운드",
            moreInsights: "인사이트 더보기",
            lessInsights: "인사이트 숨기기",
            byTopic: "주제별",
            byMarket: "시장별",
            openListTitle: "최근 뉴스",
            exploreHint: "주제를 눌러 필터링",
            loadError: "미디어 인사이트를 불러오지 못했습니다",
            retry: "다시 시도",
            none: "—",
        },
        pitch: {
            headline: "Pubrio · 신규 국가로 진출하는 기업을 찾아보세요.",
            body: "매일 수천 개의 기업이 새로운 시장에 진출합니다. 마지막이 아닌 첫 번째 연락처가 되십시오.",
            dismiss: "닫기",
        },
        kpi: {
            title: "핵심 확장 지표",
            mostActiveMarket: "가장 활발한 시장",
            yourFocus: "주력 시장",
            companiesInWindow: "신규 시그널 보유 {n}개 · {window}",
            bestToContact: "지금 연락하기 좋은 시점",
            inExpandingStage: "확장 단계",
            movingUnusuallyFast: "비정상적으로 빠르게 성장 중",
            aheadOfPace: "일반적인 속도보다 빠름",
            hot: "핫",
            newActivity: "신규 활동 시그널",
            activeMarkets: "활성 시장",
            thisWeek: "이번 주",
            last30Days: "최근 30일",
            movementHeadline: "이번 기간의 신규 활동",
            movementHint: "전체 {total}개 시장 중 {active}개",
            // Tile 2-4 hint suffixes — GLOBAL mode appends a country chip,
            // SELECTED mode reuses tile 1's focus country and drops the chip.
            hintOfMarket: "시장의 {rate}",
            hintOfFocus: "{country} 기업의 {rate}",
            hintAheadOfPaceGlobal: "{rate}가 평균보다 빠름",
            hintAheadOfPaceFocus: "{country} 기업의 {rate}가 평균보다 빠름",
            hintNewThisWeekGlobal: "{rate}가 이번 주 신규",
            hintNewThisWeekFocus: "{country} 기업의 {rate}가 이번 주 신규",
            // Empty state for SELECTED mode when the picked country has no data
            // in the active date window.
            noDataInWindow: "이 기간에는 아직 시그널이 없습니다",
        },
        competitive: {
            heading: "경쟁사 확장 비교",
            subCurated: "{name}의 해외 확장을 경쟁사와 비교",
            comparingAgainst: "비교 대상",
            addCompetitor: "경쟁사 추가",
            addSearching: "검색 중…",
            addEmpty: "회사를 찾을 수 없습니다",
            removeCompetitor: "제거",
            takeawayLead: "{metric} 부문에서 {name}이(가) 경쟁사 {n}곳을 앞서고 있습니다.",
            takeawayRank: "{metric} 부문에서 {name}은(는) 경쟁사 {total}곳 중 {rank}위입니다.",
            colCompany: "회사",
            colMarket: "시장",
            colActiveMarkets: "시장",
            colNewMarkets: "신규 시장",
            colMomentumPct: "모멘텀",
            colSignalCount: "활동량",
            colExpansionScore: "확장 점수",
            colWindowExpansionScore: "최근 점수",
            colIndustry: "산업",
            colCountry: "본사",
            colEmployees: "직원 수",
            colFounded: "설립 연도",
            colWebsite: "웹사이트",
            colTopMarket: "주요 확장 시장",
            colNewestMarket: "최근 진출",
            colScaling: "규모 확대",
            colPipeline: "파이프라인",
            colMatch: "유사도",
            columns: "열",
            columnsHint: "비교 항목 추가",
            fieldsGroupExpansion: "확장 지표",
            fieldsGroupCompany: "회사 정보",
            you: "자사",
            openCompany: "회사 열기",
            pendingHint: "확장 데이터 불러오는 중",
            empty: "확장 데이터가 있는 경쟁사가 아직 없습니다.",
            cellSignals: "시그널 {n}개",
            hoverHint: "시장 지표에 마우스를 올리면 실제 국가를 볼 수 있습니다.",
            coverageTitle: "시장 커버리지",
            coverageSub: "각 경쟁사가 어느 시장에 얼마나 깊이 진출했는지 — {total}개 시장 중 {gaps}개는 그들은 있고 당신은 없는 시장입니다.",
            covAll: "전체",
            covGaps: "공백",
            covYours: "자사",
            watch: "시장 관심 등록",
            fieldCaption: "막대는 상대적 규모, 미니 차트는 경쟁사별 주간 활동 추세.",
            legendStage: "색 = 단계",
            legendRecent: "최근 활동",
            covYouHint: "음영 = 자사",
            coverageCount: "{total}곳 중 {n}곳 진출",
            cellTypes: "시그널 유형",
            cellSince: "최초 감지",
            cellActive: "{t} 활동",
            sortLabel: "시장 정렬",
            covSortCoverage: "커버리지",
            covSortRecent: "최근",
            searchMarket: "시장 검색…",
            noMarkets: "필터와 일치하는 시장이 없습니다.",
        },
        verdict: {
            newMarkets: "신규 시장",
            momentum: "모멘텀",
            expansionScore: "확장 점수",
            vsPrior: "이전 기간 대비",
            noneThisPeriod: "이번 기간 없음",
            signalsLabel: "시그널",
            scoreVeryStrong: "매우 강함",
            scoreStrong: "강함",
            scoreDeveloping: "발전 중",
            scoreEarly: "초기 단계",
        },
        summary: {
            heading: "글로벌 확장",
            subheading: "이 기업이 운영 중인 지역과 진출하고 있는 시장입니다.",
            subheadingCount: "전 세계 {n}개 시장 — 어디서 시작했고, 지금 어디서 성장하고 있는지 보여줍니다.",
            founded: "설립",
            employees: "명",
            markets: "시장",
            marketsHintFrom: "{hq}에서 확장 중",
            marketsHintWorldwide: "전 세계 진출",
            furthestStage: "최고 도달 단계",
            movingNow: "현재 진행 중",
            movingNowHint: "최근 90일 내 진전",
            upToMarkets: "최대 {n}개 시장",
            stages: "단계",
            loading: "확장 데이터 로딩 중…",
            empty: "이 기업에 대해 아직 추적된 확장 시그널이 없습니다.",
            emptyTitle: "확장 시그널을 수집하는 중",
            emptyDetail: "아직 표시할 내용이 없습니다. {company}이(가) 신규 시장에서 채용하거나 뉴스를 내거나 광고를 집행하면 시그널이 여기에 표시됩니다.",
            thisCompany: "이 기업",
            established: "정착됨",
            establishedTip: "이 시장들에서 운영 중 — 신규 확장 활동 없음",
            establishedNote: "{company}은(는) {n}개 시장에 정착했습니다 — 이 기간에 신규 확장 활동이 없습니다.",
            errorTitle: "시그널 서비스에 연결할 수 없습니다",
            errorDetail: "지금 확장 데이터를 불러올 수 없습니다. 보통 일시적인 문제이니 다시 시도해 주세요.",
            retry: "다시 시도",
            tipMarket: "시장별 필터",
            tipDate: "기간 변경",
            tipStage: "라이프사이클 단계별 필터",
            tipExport: "이 기업 내보내기",
            tipClear: "모든 필터 지우기",
            insight: "전체 {total}개 시장 · {year}년에 {market}에 처음 진출 · 최근 90일 내 {moving}개 진전",
            insightNoFirst: "전체 {total}개 시장 · 최근 90일 내 {moving}개 진전",
            timeAll: "전체 기간",
            time12m: "12개월",
            time6m: "6개월",
            time3m: "3개월",
            filterFocus: "주력 시장",
            filterAll: "전체 시장",
            filterMore: "+{n}개 더",
            filterClear: "지우기",
            filterShowing: "전체 {total}개 시장 중 {n}개",
        },
        pulse: {
            heading: "활동 펄스",
            windowHint: "기간은 위의 날짜 필터를 따릅니다",
            catHiring: "채용",
            catMarketing: "마케팅 & PR",
            catProduct: "제품 & 기술",
            catFootprint: "거점",
            catPartners: "파트너십",
            leadMore: "{type} +{n}",
            leadNone: "활동 없음",
            trendNew: "신규",
            trendSteady: "유지",
            trendEnded: "종료",
            recentEvents: "최근 이벤트",
            headcountReduction: "인력 감축",
            postingCount: "같은 직무 채용 {n}건",
            loadMore: "더 불러오기",
            loadingMore: "로딩 중…",
            viewSource: "출처 보기",
            via: "출처: {source}",
            sourceNews: "뉴스",
            sourceJobs: "채용 공고",
            sourceAds: "광고",
            focusMarket: "피드에서 {market} 집중 보기",
            drillSub: "시그널 {n}개 · {types}개 유형 활성",
            hQuiet: "모든 시장에서 잠잠함 — 이 기간에 시그널이 없습니다.",
            hNew: "신규 {category} 활동 — 새로운 시그널 {n}개가 방금 나타났습니다.",
            hRising: "{category}이(가) 가속화 중 — 이전 기간 대비 {pct}% 증가.",
            hTop: "{category}에서 가장 활발함 — {type}이(가) 주도 (시그널 {n}개).",
            hTopPlain: "{category}에서 가장 활발함 — 시그널 {n}개.",
        },
        portfolio: {
            heading: "확장 포트폴리오",
            markets: "개 시장",
        },
        timeline: {
            heading: "시장 진출 타임라인",
            subEntry: "이 기업이 각 시장에 진출한 순서 — 오래된 순부터 최신 순까지",
            subMomentum: "최근 단계 모멘텀 기준 시장 순위",
            byEntry: "진출 순",
            byMomentum: "모멘텀 순",
            signals: "개 시그널",
            signalTypes: "개 시그널 유형",
            stageUp: "단계 상승 · {when}",
            stageUpToday: "단계 상승 · 오늘",
            now: "현재",
            firstSignal: "첫 시그널 감지",
            longEstablished: "오래 전부터 정착",
            ordinalEntered: "{ord} 번째 진출 시장",
            trackedDays: "{n}일 추적",
            trackedMonths: "{n}개월 추적",
            trackedYears: "{n}년 추적",
            confidence: "신뢰도 {n}%",
            empty: "이 필터에 해당하는 시장이 없습니다.",
            showAll: "전체 {n}개 보기",
            showLess: "간략히 보기",
        },
        feed: {
            signalsIn: "시그널 위치",
            signals: "개 시그널",
            via: "출처: {source}",
            reached: "{stage} 도달",
            firstSignal: "첫 시그널",
            show: "{n}개 보기",
            hide: "숨기기",
            empty: "이 시장에서는 아직 감지된 시그널이 없습니다.",
            emptyHint: "지도에서 다른 시장을 선택하거나 기간을 넓혀 더 많은 활동을 확인해 보세요.",
            pickTitle: "시장을 선택하세요",
            pickHint: "타임라인에서 시장을 선택하면 해당 시그널을 살펴볼 수 있습니다.",
            noMarketsTitle: "표시할 시장이 없습니다",
            noMarketsHint: "필터를 조정하여 시장을 다시 표시하세요.",
            loadMore: "시그널 더 불러오기",
        },
        journey: {
            wentFirst: "가장 먼저 진출",
            wentFirstSub: "확장한 순서대로",
            movingNow: "현재 진행 중",
            movingNowSub: "최근 단계 모멘텀",
            none: "아직 확장 시장이 없습니다",
            showAll: "전체 {n}개 보기",
            showLess: "간략히 보기",
        },
        dateRange: {
            today: "오늘",
            last7: "최근 7일",
            last30: "최근 30일",
            last90: "최근 90일",
            last12m: "최근 12개월",
            customLabel: "사용자 지정 기간",
            startPlaceholder: "시작일",
            endPlaceholder: "종료일",
        },
        countryChips: {
            title: "시장",
            subtitle: "대시보드 범위를 지정할 국가를 선택하세요",
            ariaLabel: "팔로우 중인 시장",
            addMarket: "시장 추가",
            compare: "비교",
            more: "더 보기",
            remove: "시장 제거",
            comparingNMarkets: "{n}개 시장 비교 중 | {n}개 시장 비교 중",
            pickMarketsToCompare: "비교할 시장을 클릭하세요",
            multiSelectOff: "다중 선택",
            multiSelectOnN: "다중 선택 · {n}",
        },
        mapMode: {
            toggleAriaLabel: "지도 보기 모드",
            global: "전체 시장",
            intoCountry: "인바운드",
            outgoing: "아웃바운드",
            outgoingHint: "선택한 국가에서 진출하는 기업 보기",
            outgoingDisabledHint: "아웃바운드 진출을 보려면 먼저 국가를 선택하세요",
            backToOverview: "개요로 돌아가기",
            // TODO: translate (placeholders copied from en.js)
            intoCountryHint: "Companies expanding INTO the selected country",
            intoCountryDisabledHint: "Pick a country first to see inbound flow",
        },
        find: {
            heading: "무엇을 찾고 계신가요?",
            placeholderHero: "시장을 설명하세요 — 예: 독일로 확장하는 AI 기업",
            placeholderDocked: "시장을 설명하세요",
            submit: "찾기",
            clear: "지우기",
            hintPrefix: "예시:",
            examples: [
                "미국으로 확장하는 핀테크 기업",
                "독일로 공격적으로 확장하는 AI 기업",
                "영국으로 확장하는 기업",
                "일본으로 확장하는 AI 기업",
                "프랑스로 확장하는 독일 기업",
                "싱가포르로 확장하는 기업",
            ],
            noMatch: "필터로 변환할 수 없습니다. 시장, 단계 또는 업종을 지정해 보세요.",
        },
        compare: {
            title: "시장 비교",
            pickMarket: "시장을 선택하세요",
            emptyHint: "비교할 시장을 추가하세요",
            totalCompanies: "추적 중인 기업 수",
            readyToContact: "연락 준비 완료 (확장)",
            newThisMonth: "이번 달 신규 전환",
            aheadOfPace: "평균보다 빠른 진행 (30일)",
            stageBreakdown: "단계별 분포",
            expandingShareLabel: "준비 완료",
            viewMarket: "이 시장 보기",
            viewMarketAction: "보기",
            addColumn: "시장 추가",
            removeColumn: "이 시장 제거",
            metricHeader: "지표",
            deltaHeader: "Δ",
            winnerBadgeTitle: "선택한 시장 중 최고",
            lensLabel: "비교 기준",
            lensVolume: "전체",
            lensShare: "비율 %",
            lensShareHint: "각 지표를 해당 시장의 추적 기업 수 대비 %로 표시",
            insightTitle: "인사이트",
            insightOverall: "{winner}이(가) 전체 {total}개 지표 중 {n}개에서 선두입니다.",
            insightExpanding: "{winner}이(가) 현재 {loser}보다 연락 준비된 기업이 {n}개 더 많습니다.",
            insightMomentumMultiple: "{winner}이(가) 이번 달 {loser}보다 {multiple}배 빠르게 신규 기업을 확보 중입니다.",
            insightMomentumAbsolute: "{winner}이(가) 이번 달 신규 기업 {n}개를 추가했습니다 — {loser}은(는) 0개입니다.",
            insightPace: "{market}에 일반보다 빠르게 움직이는 기업이 {n}개 있습니다 — 자세히 살펴볼 가치가 있습니다.",
            insightAboveWeight: "{winner}이(가) 체급 이상의 성과를 내고 있습니다 — 시장의 {winnerPct}가 연락 준비 완료 상태이며, {larger}의 {largerPct}와 비교됩니다.",
            dimExpanding: "연락 준비 완료",
            dimNewThisMonth: "이번 달 신규",
            dimAheadOfPace: "평균보다 빠름",
            dimTotal: "전체 추적",
            dimTotalShare: "선택 대비 비율",
            drillCellTitle: "{country} 열기",
            drillCellTitleStage: "{country} 열기 — {stage} 단계",
            drillSegTitle: "{country} 열기 — {stage} ({n}개 기업)",
            viewCrossMarket: "{n}개 시장에서 검색",
            summaryWinner: "{winner}이(가) {loser}보다 연락 준비된 기업이 {n}개 더 많습니다.",
            summaryTie: "두 시장 모두 동일한 수의 연락 준비된 기업을 보유하고 있습니다.",
        },
        countryPicker: {
            title: "시장 추가",
            searchPlaceholder: "국가명 또는 코드 검색…",
            noMatch: "검색 조건에 일치하는 국가가 없습니다.",
        },
        stageTiles: {
            title: "단계별 분포",
            subtitle: "아래 목록을 필터링하려면 단계를 클릭하세요",
            ariaLabel: "확장 단계",
            bestToReachOut: "연락하기 가장 좋은 시점",
            signalsHeading: "판단에 사용하는 신호",
            signalSoon: "예정",
            infoAria: "이 단계 판정 방법",
        },
        stage: {
            exploring: "탐색",
            exploringDescription: "이제 막 살펴보는 중",
            committing: "투입",
            committingDescription: "실질적인 리소스를 투입 중",
            expanding: "확장",
            expandingDescription: "현지 기반을 키우는 중",
            scaling: "규모 확대",
            scalingDescription: "현지 사업 규모를 키우는 중",
        },
        signal: {
            ad: "지역 타겟팅 광고",
            event: "컨퍼런스 참가",
            news: "뉴스 / PR",
            dns: "도메인 / SSL",
            tech: "제품 현지화",
            infra: "클라우드 / 인프라",
            ip: "상표 / 특허",
            partner: "파트너십",
            eventPlus: "전시 / 강연",
            reg: "규제 라이선스",
            entity: "법인 등록",
            exec: "임원 채용",
            office: "사무실 임대",
            hire: "현지 인력 채용",
            scale: "인원 확대",
            product: "제품 출시",
        },
        signalTier: {
            premier: "프리미어",
        },
        direction: {
            advancing: "진전",
            steady: "유지",
            retreating: "후퇴",
            new: "신규",
        },
        freshness: {
            fresh: "신선",
            cooling: "식어가는",
            stale: "오래된",
            cold: "콜드",
        },
        filters: {
            title: "필터",
            clearAll: "모두 지우기",
            direction: "방향",
            freshness: "신선도",
            employees: "임직원 수",
            industry: "산업",
            risk: "리스크",
            stage: "단계",
            scope: "범위",
            founded: "설립연도",
            signalStrength: "시그널 강도",
            signalVolume: "시그널 수",
            momentum: "모멘텀",
            momentumAccelerating: "가속 중",
            momentumAdvancing: "전진 중",
            momentumSteady: "유지",
            momentumPullingBack: "후퇴 중",
            signalVolumeAny: "전체",
            signalVolumeWord: "시그널",
            onlyAtRisk: "리스크 시장만",
            any: "전체",
            employeesCustomRange: "사용자 지정 범위",
            predefinedRange: "사전 정의된 범위",
            employeesPlaceholder: "규모 범위 선택",
            industrySubCategory: "세부 산업",
            industryCategory: "산업 카테고리",
            industrySubCategoryPlaceholder: "세부 산업 입력",
            industryCategoryPlaceholder: "산업 카테고리 입력",
            foundedRange: "설립 연도",
            foundedFrom: "시작",
            foundedTo: "종료",
            min: "최소",
            max: "최대",
            // TODO: translate (placeholders copied from en.js)
            signalType: "시그널 유형",
            pace: "속도",
            onlyAheadOfPace: "속도가 빠른 곳만",
            paceHint: "첫 시그널부터 최신 전환까지 걸린 기간이 해당 국가에서 가장 빠른 사분위에 속하는 회사.",
            searchPlaceholder: "필터 검색…",
            presets: "필터 프리셋",
            presetsSavedCount: "{n}개 저장됨",
            activeOne: "필터 {n}개 적용 중",
            activeMany: "필터 {n}개 적용 중",
            save: "저장",
            clearShort: "지우기",
            groupScope: "범위",
            groupSignal: "확장 시그널",
            groupSources: "소스",
            groupCompany: "회사 프로필",
            date: "날짜",
            markets: "진출 · 대상 시장",
            flowDirection: "흐름 방향",
            marketsPlaceholder: "어디로 확장하는지(목적지)",
            marketsFrom: "출발 · 본거지 시장",
            marketsAny: "시장 · 방향 무관",
            marketsFromPlaceholder: "어디에서 확장하는지(출발지)",
            marketsAnyPlaceholder: "진출하거나 출발하는 모든 시장",
            noMatchingFilters: "일치하는 필터 없음",
            addFilter: "필터 추가",
            groupRecent: "최근",
            groupSuggested: "추천",
            savedViews: "저장된 필터",
            savedViewsCount: "{n}개 저장됨",
            noSavedViews: "저장된 필터가 아직 없습니다.",
            saveCurrentView: "현재 필터 저장",
            deleteView: "필터 삭제",
            deleteConfirm: "삭제",
            cancel: "취소",
            confirmDeleteView: "저장된 필터 “{name}”을(를) 삭제할까요?",
            saveDialogTitle: "필터 저장",
            namePrompt: "나중에 불러올 수 있도록 필터 이름을 지정하세요.",
            namePlaceholder: "예: 주목받는 유럽 SaaS",
            nameRequired: "필터 이름을 입력하세요.",
            location: "출발 · 회사 본사",
            locationPlaceholder: "본사 위치(출발지)",
            locationHint: "회사의 본거지 시장입니다. 대상 시장과 함께 지정하면 「출발 → 진출」 코리도(예: 싱가포르 → 일본)를 볼 수 있습니다.",
            revenue: "매출",
            revenueRange: "연 매출(USD)",
            revenueMin: "최소($)",
            revenueMax: "최대($)",
            revenueHint: "보강 데이터 기반의 예상 연 매출 범위입니다.",
            specialties: "전문 분야",
            specialtiesPlaceholder: "전문 분야 검색…",
            technologies: "기술",
            technologiesPlaceholder: "기술 검색…",
            companies: "회사",
            companiesPlaceholder: "회사 검색…",
            activeTitle: "적용 중",
            activeEmpty: "적용된 필터 없음",
            dateChipPrefix: "날짜",
            marketChipPrefix: "시장",
            savedListChip: "저장된 목록",
            savedListFilterNote: "회사별로 도달한 최고 단계 기준 한 행씩 표시합니다. 단계 타일은 목록 수와 일치합니다.",
            originChipPrefix: "출발",
            targetChipPrefix: "진출",
            removeFilter: "{label} 제거",
          stageDesc: "해당 시장에서 회사가 얼마나 활발한지 — 첫 시그널부터 규모 확대까지.",
          momentumDesc: "확장의 추세 방향 — 가속, 유지, 후퇴 중 하나.",
          signalVolumeDesc: "감지된 확장 시그널의 수. 시그널이 많을수록 활동이 활발합니다.",
          signalTypeDesc: "시그널의 종류 — 채용, 광고, 신규 사무실, 뉴스 등.",
          freshnessDesc: "최신 시그널이 얼마나 최근인지.",
          scopeDesc: "완전히 새로운 시장 진입인지, 기존 거점을 강화하는지.",
          signalTypeUnavailable: "출시 예정 — 이 시그널은 아직 제공되지 않습니다",
          excludeMarkets: "시장 제외",
          excludeMarketsPlaceholder: "제외할 시장…",
          excludeOrigins: "출발지 제외",
          excludeOriginsPlaceholder: "제외할 출발지…",
          excludeIndustry: "산업 제외",
          excludeIndustryPlaceholder: "제외할 산업…",
        },
        scope: {
            enteringNewMarket: "신규 시장 진출",
            expandingWithinPresence: "기존 진출 시장 내 확장",
            establishedOnly: "기진출만",
        },
        signalStrength: {
            high: "높은 신뢰도",
            medium: "중간",
            low: "낮음",
        },
        row: {
            employees: "임직원",
            marketsCount: "{n}개 시장",
            marketsActiveIn: "활동 시장: {list}",
            founded: "설립",
            journey: "여정",
            journeyLabel: "여정",
            contractionFlag: "{days}일간 신규 시그널 없음. 이 기업은 확장을 중단하거나 철수 중일 수 있습니다.",
            noSignalsInDays: "{days}일간 신규 시그널 없음. 이 기업은 확장을 중단하거나 철수 중일 수 있습니다.",
            movingFast: "빠르게 진행 중",
            movingFastDetail: "{months}개월 만에 {stages}.",
            addToSequence: "시퀀스에 추가",
            saveToList: "리스트에 저장",
            viewProfile: "프로필 보기",
            viewSignalsHint: "모든 시그널을 보려면 클릭",
            signalCount: "시그널 {n}개",
            distinctTypes: "시그널 유형 {n}개",
            stageUpInDays: "단계 상승 · {days}일 전",
            stageUpToday: "단계 상승 · 오늘",
            newInDays: "신규 · {days}일",
            newToday: "신규 · 오늘",
            selectRow: "기업 선택",
            lastSignal: "최근 시그널",
            // TODO: translate (placeholders copied from en.js)
            contractionFlag_leading: "Early signs of contraction — multiple leading indicators (exec departures, layoff chatter) in the last 60 days.",
            contractionFlag_confirming: "Recent contraction signal — a layoff or downsizing was reported in the last 180 days.",
            contractionFlag_lagging: "Confirmed retreat — a market exit, office closure or de-registration in the last 12 months.",
            contractionFlag_leading_mixed: "Mixed signals — early contraction indicators alongside ongoing expansion activity. Watch closely.",
            contractionFlag_confirming_mixed: "Mixed signals — a recent contraction signal sits alongside fresh expansion activity. Confidence is split; review before acting.",
            stageOf: "Stage {n} of {total}",
            tooltipDirection_advancing: "Moved up at least one stage in the last 30 days",
            tooltipDirection_steady: "No stage change in the last 30 days",
            tooltipDirection_retreating: "Fewer recent signals — this company may be pulling back from this market",
            tooltipDirection_new: "Just appeared as a potential expander",
            tooltipFreshness_fresh: "Last signal in the past 30 days",
            tooltipFreshness_cooling: "Last signal 30 to 60 days ago",
            tooltipFreshness_stale: "Last signal 60 to 90 days ago — activity has cooled",
            tooltipFreshness_cold: "No signals in the past 90 days",
            tooltipSignalCount: "Total expansion signals tracked for this company ({n})",
            tooltipDistinctTypes: "{n} different kinds of signal (hiring, news, office lease, etc.)",
            tooltipStageUp: "Recently moved up to the {stage} stage",
            tooltipNew: "First signal detected recently",
            tooltipSignalType: "Signal type: {type}",
        },
        list: {
            title: "{count}개 기업",
            titleAll: "{country}의 {count}개 기업",
            titleAllGlobal: "전체 시장에서 {count}개 기업",
            titleStageScoped: "{stage} 단계의 {count}개 기업 — {country}",
            titleStageScopedGlobal: "{stage} 단계의 {count}개 기업 — 전체 시장",
            filteredBy: "필터 기준",
            export: "내보내기",
            previous: "이전",
            next: "다음",
            pageOf: "{total} 페이지 중 {page} 페이지",
            selectAll: "전체 선택",
            selectAllOption: "전체",
            selectThisPage: "현재 페이지",
            selectCustomize: "사용자 지정",
            selectHint: "이 보기에서 최대 {count}개의 기업을 선택할 수 있습니다.",
            applySelection: "적용",
            selected: "{n}개 선택됨",
            bulkSequence: "시퀀스에 추가",
            bulkSave: "리스트에 저장",
            bulkExport: "선택 항목 내보내기",
            findPeople: "인물 찾기",
            clearSelection: "선택 해제",
            paceHint: "{country}의 탐색 → 확장 중간값은 6개월입니다. {n}개 기업이 평균보다 빠릅니다.",
            movingFast: "빠르게 진행 중",
            movingFastDetail: "4개월 만에 탐색 → 규모 확대. {country}의 SaaS 평균은 6개월입니다.",
            emptyTitle: "아직 이 보기에 해당하는 기업이 없습니다.",
            emptyBody: "다른 시장을 선택하거나 새로운 시그널이 도착할 때까지 기다려 보세요.",
            emptyStageTitle: "현재 이 단계에 해당하는 기업이 없습니다.",
            emptyStageBody: "다른 단계를 선택하여 계속 탐색해 보세요.",
            pickCountryTitle: "시작할 국가를 선택하세요.",
            pickCountryBody: "위의 시장 칩을 클릭하거나 지도를 사용해 대시보드 범위를 지정하세요.",
        },
        map: {
            topSectors: "주요 업종",
            expandingInto: "진출 대상",
            comingFrom: "유입 출처",
            tabWhatsNew: "새 소식",
            whatsNewAriaLabel: "시장 동향 인사이트",
            whatsNewCaptionCountry: "{country} 진출 동향 · {window}",
            whatsNewCaptionGlobal: "전체 시장 동향 · {window}",
            whatsNewCaptionMulti: "{n}개 시장 동향 · {window}",
            whatsNewCorridorHint: "목록을 {from} → {to}(으)로 필터링",
            whatsNewDeltaFlat: "변동 없음",
            whatsNewDeltaNew: "신규",
            whatsNewDestinationHint: "{country}에 대시보드 집중",
            whatsNewEmpty: "선택한 기간에 전환이 없습니다. 지도 컨트롤에서 더 넓은 기간을 선택해 보세요.",
            whatsNewFastEmptyBody: "기간을 넓히거나 국가 필터를 해제하여 평균보다 빠르게 움직이는 기업을 확인하세요.",
            whatsNewFastEmptyTitle: "이 화면에 빠르게 움직이는 기업이 없습니다",
            whatsNewFastExplainer: "해당 시장 동종 기업의 75%보다 빠르게 진행 중인 기업입니다.",
            whatsNewFastMoversTitle: "평균보다 앞서가는 기업",
            whatsNewForYouEmptyBody: "저장한 기업 중 이 기간에 단계 전환이 있었던 기업이 없습니다. 기간을 넓히거나 나중에 다시 확인하세요.",
            whatsNewForYouEmptyTitle: "목록에 새로운 움직임이 없습니다",
            whatsNewForYouExplainer: "이 기간에 구성원이 움직인 저장된 기업 목록입니다.",
            whatsNewFoundedYear: "{year}년 설립",
            whatsNewHotCorridors: "인기 경로",
            whatsNewListCount: "{n}개 기업",
            whatsNewListUpdated: "{time} 업데이트됨",
            whatsNewLoading: "집계 중…",
            whatsNewMarketsCount: "{n}개 신규 시장",
            whatsNewMarketsInlineMore: "+{n}개 더",
            whatsNewMovesLabel: "이번 기간 움직임",
            whatsNewMovingFastDetail: "{from} → {to}, {months}개월 만에",
            whatsNewNotableMovers: "주목할 움직임",
            whatsNewOpenList: "목록 열기: {name}",
            whatsNewOriginHint: "{country} 출신 기업으로 필터링",
            whatsNewPipelineMix: "단계 분포",
            whatsNewPrevDay: "어제",
            whatsNewPrevDays: "지난 {n}일",
            whatsNewPrevMonth: "지난달",
            whatsNewPrevWeek: "지난주",
            whatsNewSavedListMovers: "{count}개 기업에 새 움직임",
            whatsNewSavedListMoversAriaLabel: "이 목록에서 {count}개 기업에 새 움직임",
            whatsNewSavedListTotal: "총 {total}개",
            whatsNewScopeGlobal: "전체 시장",
            whatsNewScopeMulti: "{n}개 시장",
            whatsNewStageHint: "{stage} 단계로 필터링",
            whatsNewStageUpAt: "단계 상승 · {time}",
            whatsNewStageVelocity: "단계 속도",
            whatsNewStoryCool: "{from} → {to} {delta}% 둔화",
            whatsNewStoryDeltaDetail: "이번 기간 {current}건 vs 이전 기간 {previous}건",
            whatsNewStoryMover: "{company}이(가) 방금 {stage}에 도달",
            whatsNewStoryNew: "{from} → {to} 경로가 이번 기간에 신규 등장",
            whatsNewStoryNewDetail: "{n}개 기업이 방금 이동 — 처음 추적된 경로",
            whatsNewStoryStageDetail: "{n}개 기업이 방금 {stage}에 도달",
            whatsNewStoryStageDown: "{stage} 단계 전환 {delta}% 감소",
            whatsNewStoryStageUp: "{stage} 단계 전환 {delta}% 증가",
            whatsNewStorySurge: "{from} → {to} {delta}% 급증",
            whatsNewSurgingDestinations: "급증하는 목적지",
            whatsNewSurgingOrigins: "급증하는 출발지",
            whatsNewTabFastMovers: "빠른 진행",
            whatsNewTabForYou: "맞춤 추천",
            whatsNewTabWideExpanders: "광범위 확장",
            whatsNewUnnamedList: "제목 없는 목록",
            whatsNewVelocityDetail: "이전 {window}에는 {previous}개",
            whatsNewVelocityDetailNoPrior: "의미 있는 활동이 있는 첫 기간",
            whatsNewVelocityTitle: "이번 기간 {n}개 기업 {verb}",
            whatsNewVerbAcross: "추적된 국경 간 움직임",
            whatsNewVerbInto: "{scope} 진출",
            whatsNewViewAll: "목록의 모든 기업 보기",
            whatsNewViewAllN: "{n}개 기업 모두 보기",
            whatsNewViewList: "전체 기업 목록 보기",
            whatsNewMarketsChip: "{n}개 이상 시장 진출",
            whatsNewVsPrev: "{label} {n}건 대비",
            whatsNewWhereFrom: "주요 출신지",
            whatsNewWideEmptyBody: "기간을 넓히거나 국가 필터를 해제하여 한 번에 여러 시장에 진출하는 기업을 확인하세요.",
            whatsNewWideEmptyTitle: "이 화면에 광범위 확장 기업이 없습니다",
            whatsNewWideExplainer: "한 번에 3개 이상의 신규 시장에 진출한 기업 — 공격적인 다국가 확장.",
            whatsNewWindowDays: "지난 {n}일",
            whatsNewWindowMonth: "지난 30일",
            whatsNewWindowToday: "오늘",
            whatsNewWindowWeek: "지난 7일",
            placeholderAriaLabel: "확장 세계 지도",
            loadingBasemap: "지도 로딩 중…",
            loadingCountry: "시장 데이터 로딩 중…",
            loadingDashboard: "확장 데이터 로딩 중…",
            newThisMonthIn: "{country}의 이번 달 신규",
            newTransitionsAllMarkets: "이번 달 신규 전환",
            readyToContact: "연락 준비 완료",
            tracked: "추적 총계",
            activeMarkets: "활성 시장",
            ctaReadyToContact: "연락 준비된 {n}개 보기",
            origins: {
                title: "주요 출발지 → {country}",
                total: "{n}개 국경 간",
                domestic: "+{n}개 국내 ({country} → {country})",
                untracked: "+{n}개 미추적 출발지",
                empty: "아직 이 시장에 대한 출발지 데이터가 없습니다.",
                plusMore: "+{n}개 출발지 더 보기",
                clearFilter: "출발지 필터 해제",
            },
            timeFilterLabel: "시그널 표시 기간",
            timeFilterToday: "오늘",
            timeFilterWeek: "이번 주",
            timeFilterMonth: "이번 달",
            timeFilterAll: "전체 기간",
            activityFeedTitle: "새로운 소식",
            activityFeedEmpty: "선택한 기간에 신규 활동이 없습니다.",
            activityFeedFooter: "모든 활동 보기 →",
            activityFeedAdvanced: "{stage} 도달",
            activityFeedNew: "신규 시그널 감지됨",
            activityFeedFrom: "{country}발",
            activityFeedTitleHint: "클릭하여 회사 상세 보기",
            activityFeedTitleHintCountry: "클릭하여 이 시장으로 좁히기",
            marketIntelTitle: "시장 인텔리전스",
            tabOrigins: "주요 출발지",
            tabActivity: "방금 이동",
            showActivity: "시장 인텔리전스 표시",
            hideActivity: "시장 인텔리전스 숨기기",
            windowEmptyBody: "기간을 넓히면 이 회사의 활동이 표시됩니다.",
      noActivityTitle: "이 보기에는 아직 움직임이 없습니다.",
            noActivityBody: "다른 시장을 선택하거나 글로벌 흐름으로 전환해 보세요.",
            noOutgoingTitle: "아직 {country}에서 아웃바운드 시그널이 없습니다",
            noOutgoingBody: "현재 데이터에서 {country}에서 진출하는 기업이 감지되지 않았습니다. 이 국가로 진입하는 기업을 보려면 선택한 시장 보기로 전환해 보세요.",
            noOutgoingCta: "이 시장으로 진출하는 기업 보기",
            companiesCount: "기업 {n}개 | 기업 {n}개",
            newThisMonthCount: "이번 달 신규 {n}개",
            clickHint: "시장 위에 마우스를 올려 상세 정보 확인 · 클릭하여 드릴 다운",
            zoomIn: "확대",
            zoomOut: "축소",
            resetView: "보기 초기화",
            densityShowN: "최대 시장 {n}개 | 최대 시장 {n}개",
            densitySliderAriaLabel: "지도 밀도 — 슬라이드하여 출발지 표시 수 조정",
            legendAriaLabel: "지도 범례",
            legendTitle: "단계",
            legendSectionRecent: "최근 활동",
            legendStageUp: "진전",
            legendStageUpTitle: "시안색 링은 최근 30일 내 단계가 상승한 국가를 표시합니다",
            legendNew: "신규",
            legendNewTitle: "빛나는 점은 최근 90일 내 확장을 시작한 국가를 표시합니다",
            legendBadge30d: "30일",
            legendBadge90d: "90일",
            legendCollapse: "범례 최소화",
            legendExpand: "범례 표시",
            companies: "기업",
            // TODO: translate (placeholders copied from en.js)
            activityFeedEmptyGlobal: "Pick a market above to see companies that just moved stages.",
        },
        tooltip: {
            signals: "시그널",
            companiesMoving: "이동 중인 기업",
            companiesExpandingFrom: "여기서 진출하는 기업",
            companiesArrivingAt: "이 출발지에서 도착하는 기업",
            clickToScope: "클릭하여 목록 필터링 →",
        },
        popover: {
            close: "닫기",
            loading: "상세 정보 로딩 중…",
            loadFailed: "이 시장을 불러올 수 없습니다.",
            keyMoments: "주요 순간",
            signals: "시그널 ({n})",
            firstSignal: "첫 시그널",
            latestSignal: "최근 시그널",
            reachedStage: "{stage} 도달",
            stageUp: "단계 상승",
        },
        drawer: {
            title: "기업 확장 프로필",
            currentStage: "현재 단계",
            confidence: "신뢰도",
            confidenceHigh: "높음",
            confidenceMedium: "중간",
            confidenceLow: "낮음",
            signalGeneric: "시그널",
            allSignals: "시그널 타임라인",
            signalsCount: "시그널 {n}개",
            noSignals: "이 시장 쌍에 대해 아직 수집된 상세 시그널이 없습니다.",
            contractionBanner: "축소 시그널 감지됨 — 연락 전에 이 기업이 여전히 확장 중인지 확인하세요.",
            openFullProfile: "전체 프로필 열기",
            visitWebsite: "웹사이트 방문",
            // Expansion context (route between hero card and stage strip)
            expandingInto: "진출 대상",
            expandingFrom: "출발지",
            expansionTo: "진출처",
            signalsInMarket: "시그널 위치",
            // Company overview tile
            companyAtAGlance: "기업 한눈에 보기",
            industry: "산업",
            founded: "설립",
            employees: "임직원",
            headquarters: "본사",
            website: "웹사이트",
            // Presence section
            onTheGround: "현지 거점",
            presenceOffice: "사무실",
            presenceLegal: "법인",
            presenceHiring: "채용",
            // TODO: translate
            milestoneActiveRoles: "Reached {n} active role | Reached {n} active roles",
            milestoneScale: "Reached open-roles threshold",
            // Other markets
            alsoExpandingTo: "추가 진출 시장",
            noOtherMarkets: "아직 다른 시장이 감지되지 않았습니다.",
            showAll: "모두 보기 ({n})",
            showLess: "간략히 보기",
            filterAll: "전체",
            // Pace
            paceLabel: "확장 속도",
            paceText: "첫 시그널부터 {stage}까지 {days}일",
            paceFast: "빠름",
            paceTypical: "보통",
            paceSlow: "느림",
            localTeamLabel: "현지 팀",
            lastActiveLabel: "최근 활동",
            teamPeople: "명",
            localTeamNone: "없음",
            localTeamNetNew: "신규 진출",
            localTeamEmerging: "초기 단계",
            localTeamEstablished: "이미 진출",
            localTeamNoData: "—",
            localTeamNoDataMeta: "현지 데이터 없음",
            localTeamOnSite: "현지 거점",
            readScalingTitle: "기존 팀 확장",
            readScalingDetail: "이미 {market}에 자리를 잡음 — 최근 채용과 광고는 신규 진출이 아니라 기존 현지 운영의 확장입니다.",
            readDeepeningTitle: "현지 입지 강화",
            readDeepeningDetail: "{market}에 정착한 상태에서 계속 확대 중 — 신규 진출이 아니라 기존 운영의 확장입니다.",
            readSteadyTitle: "현지 운영 중",
            readSteadyDetail: "{market}에 정착해 꾸준하고 지속적인 현지 활동을 이어가고 있습니다.",
            readEstablishingTitle: "거점 구축 중",
            readEstablishingDetail: "이미 {market}에 소규모 팀이 있음 — 최근 신호는 확대를 시사합니다.",
            paceInMarket: "현지 진출됨",
            thisMarket: "이 시장",
            readAxesFootnote: "스테이지는 최근 활동 · 팀은 규모를 나타냅니다 — 둘은 다를 수 있습니다.",
            teamFoundDetail: "{market}에서 {n}명 확인 — 실제로는 더 많을 수 있습니다.",
            // Signal labels
            signalSource: "출처: {source}",
            signalTierHint: "확보하기 어려운 인텔리전스를 Pubrio가 발굴",
            signalSourceFrom: "출처: {source} · {host}",
            signalViewSource: "출처 보기",
            signalNoEvidence: "출처 링크 없음",
            // Footer note
            poweredBy: "최근 감지된 시그널",
            // TODO: translate (placeholders copied from en.js)
            signalsCountOf: "{n} of {total} signals",
            loadMore: "Load more signals",
            switchMarket: "Switch market",
            durationDays: "{n}d",
            durationWeeks: "{n}w",
            durationMonths: "{n}mo",
            durationYears: "{n}y",
            reachedStageAt: "Reached {stage} {when}",
            transitionDuration: "{duration} in {prev}",
            signalGroupTitle: "{n} × {type}",
            signalGroupContext: "{items}",
            headcountScalingTitle: "{n} jobs currently open",
            recentSignalsChip: "{n} {type} · 12w",
            activityLabel: "Activity",
            activityWindow: "{weeks} weeks",
            activityTotal: "All",
            activityFilterByType: "Filter timeline to {type}",
            activityCellTooltip: "{n} × {type} · {week}",
            activityCellMore: "+{n} more",
            activityCellEmpty: "No {type} signals · {week}",
            activityEmpty: "Quiet for now",
            activityEmptyHint: "No signals detected in the last 12 weeks — this company's expansion engine is paused or pre-launch.",
            snapshotLabel: "Current snapshot",
            showItems: "Show {n}",
            showItemsOf: "Show {n} of {total}",
            hideItems: "Hide",
            loadingMore: "Loading…",
        },
        live: {
            title: "시장 업데이트",
            live: "실시간",
            all: "전체",
            advancing: "진전",
            retreating: "후퇴",
            tabNews: "뉴스",
            tabFunding: "투자 인사이트",
            tabJobs: "채용 공고",
            tabAds: "광고",
            sort: "정렬",
            sortNewest: "최신순",
            sortOldest: "오래된순",
            sortImpact: "영향력",
            filter: "필터",
            findPeople: "사람 찾기",
            searchPlaceholder: "검색 …",
            pendingBanner: "지난 방문 이후 신규 기사 {n}개 · 클릭하여 로드",
            empty: "아직 전환이 없습니다 — 기업이 이동하면 여기에 표시됩니다.",
            lastHour: "지난 1시간",
            advanced: "진입:",
            retreated: "후퇴:",
            decayed: "쇠퇴:",
            changed: "전환:",
        },
        trending: {
            title: "트렌딩 기업",
            mostActiveToday: "오늘 가장 활발한 기업",
            catAll: "전체",
            catTechnology: "테크놀로지",
            catFintech: "핀테크",
            catHealthcare: "헬스케어",
            catSaaS: "SaaS",
            more: "더 보기",
            empty: "아직 트렌딩 기업이 없습니다.",
        },
        toast: {
            sequenceQueued: "시퀀스 추가 화면이 열렸습니다 — 팝업에서 시퀀스를 선택하세요.",
            savedToList: "{name}을(를) 리스트에 저장했습니다.",
            saveFailed: "리스트에 저장하지 못했습니다. 다시 시도하세요.",
            exportReady: "{n}개 행을 내보냈습니다.",
            exportFailed: "내보내기에 실패했습니다 — 더 작은 배치로 시도하세요.",
        },
        export: {
            title: "확장 데이터를 CSV로 내보내기",
            body: "CSV로 {count}행을 내보내면 {price}크레딧이 차감됩니다.",
        },
        watch: {
            cta: "이 보기 관찰",
            ctaShort: "관찰",
            watching: "관찰 중",
            newCount: "신규 {n}건",
            cadenceHeading: "알림 방식",
            start: "관찰 시작",
            recommended: "추천",
            update: "모니터 업데이트",
            realtime: "실시간",
            realtimeDesc: "시그널이 도착할 때마다",
            daily: "일간 요약",
            dailyDesc: "하루 한 번 요약",
            weekly: "주간 요약",
            weeklyDesc: "매주 월요일 요약",
            statusActive: "활성",
            statusPaused: "일시중지",
            newMatches: "새 일치",
            lastChecked: "마지막 확인",
            never: "아직 실행 안 됨",
            frequency: "빈도",
            scope: "범위",
            scopeSummary: "{market} · 필터 {n}개",
            allMarkets: "모든 시장",
            viewMatches: "일치 항목 보기",
            pause: "일시중지",
            resume: "재개",
            stop: "관찰 중지",
            namePlaceholder: "모니터 이름 지정",
            defaultName: "{market} · 확장 시그널",
            monitorName: "{market} · 확장 시그널 #{date}",
            created: "관찰 중 — 새 시그널을 알려드립니다",
            updated: "모니터가 업데이트되었습니다",
            stopped: "관찰을 중지했습니다",
            paused: "모니터를 일시중지했습니다",
            resumed: "모니터를 재개했습니다",
            viewChanged: "필터가 변경되었습니다 — 모니터를 업데이트하세요",
            empty: "시장 또는 필터를 추가하여 이 보기를 관찰하세요",
        },
        widgetRail: {
            title: "추가 위젯",
            expandHint: "확장하려면 클릭",
        },
        errors: {
            loadFailed: "확장 데이터를 불러올 수 없습니다.",
            retry: "다시 시도",
        },
        time: {
            unknown: "—",
            today: "오늘",
            daysAgo: "{n}일 전",
            weeksAgo: "{n}주 전",
            monthsAgo: "{n}개월 전",
            yearsAgo: "{n}년 전",
        },
    },

};